import {useDebugValue} from 'react';

import {undef, runSLPDatePickerOpenedExperiment} from '../../../utils';

import {useSettings} from './';

const defaultSettings = {
    isOpen: false,
    readOnly: false,
    showContinueButton: true
};

function useDatesSettings(props, system, abacus) {
    const {
        datesSettings: propsSettings
    } = props;

    const overrideOptions = {
        isOpen: runSLPDatePickerOpenedExperiment(abacus, system) || undef
    };

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings, overrideOptions);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useDatesSettings};
